import { useQuery } from "@tanstack/react-query";

import { surfaceTreatmentsPredictionsQuery } from "#modules/quoteRequestLines/infra/surfaceTreatmentsPredictions.query";

export const useSurfaceTreatmentsPredictions = (quoteRequestLineId: string | undefined) => {
  const { data, ...rest } = useQuery({
    ...surfaceTreatmentsPredictionsQuery(quoteRequestLineId),
  });

  return { surfaceTreatmentsPredictions: data ?? [], ...rest };
};
